import React from "react"

import { letsHangSupportEmail } from "@letshang/constants"

interface GenericFeedbackProps {
  emailRecipient?: string
  emailSubject?: string
  fromScreen?: string
  userId?: string
  showOnDesktop?: boolean
}

const GenericFeedback: React.FC<GenericFeedbackProps> = ({
  emailRecipient = letsHangSupportEmail,
  emailSubject = "Assistance needed: Issue on Letshang app",
  fromScreen = "Unknown",
  userId = "Not provided",
  showOnDesktop = false,
}) => {
  const currentTime = new Date().toLocaleString()
  const emailBody = `Hello,\n\nI'm having an issue.\n<Please explain your issue here>\n\nReport details:\nScreen: ${fromScreen}\nTime: ${currentTime}\nUser ID: ${userId}\n\nRegards`
  const mailtoLink = `mailto:${emailRecipient}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`

  return (
    <div
      className={`${showOnDesktop ? "hidden md:flex" : "md:hidden flex"} text-white/50 flex flex-row justify-center items-center gap-2`}
    >
      <svg
        width="1rem"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.48438 17.8438C2.83594 17.8438 2.625 17.3594 3 16.8906C3.3125 16.4844 4.0625 15.6406 4.53125 14.8594C4.60938 14.7031 4.57031 14.5859 4.40625 14.5C1.80469 13.0859 0.3125 10.8047 0.3125 8.28125C0.3125 4.17969 4.39844 0.875 9.5 0.875C14.6016 0.875 18.6875 4.17969 18.6875 8.28125C18.6875 12.6875 14.4922 15.6875 8.84375 15.6953C8.77344 15.6953 8.6875 15.6875 8.58594 15.6797C8.45312 15.6797 8.32031 15.7188 8.16406 15.8281C6.69531 16.8672 4.44531 17.8438 3.48438 17.8438Z"
          fill="#7F7F7F"
          fillOpacity="0.5"
        />
        <path
          d="M3.48438 17.8438C2.83594 17.8438 2.625 17.3594 3 16.8906C3.3125 16.4844 4.0625 15.6406 4.53125 14.8594C4.60938 14.7031 4.57031 14.5859 4.40625 14.5C1.80469 13.0859 0.3125 10.8047 0.3125 8.28125C0.3125 4.17969 4.39844 0.875 9.5 0.875C14.6016 0.875 18.6875 4.17969 18.6875 8.28125C18.6875 12.6875 14.4922 15.6875 8.84375 15.6953C8.77344 15.6953 8.6875 15.6875 8.58594 15.6797C8.45312 15.6797 8.32031 15.7188 8.16406 15.8281C6.69531 16.8672 4.44531 17.8438 3.48438 17.8438Z"
          fill="#C2C2C2"
        />
      </svg>
      <p className="text-left text-md">
        Having issues? We can help.
        <a
          href={mailtoLink}
          className="underline text-white/50 hover:text-white ml-1"
        >
          Talk to our team.
        </a>
      </p>
    </div>
  )
}

export const GenericFeedbackCommon: React.FC<GenericFeedbackProps> = ({
  emailRecipient = letsHangSupportEmail,
  emailSubject = "Assistance needed: Issue on Letshang app",
  fromScreen = "Unknown",
  userId = "Not provided",
}) => {
  const currentTime = new Date().toLocaleString()
  const emailBody = `Hello,\n\nI'm having an issue.\n<Please explain your issue here>\n\nReport details:\nScreen: ${fromScreen}\nTime: ${currentTime}\nUser ID: ${userId}\n\nRegards`
  const mailtoLink = `mailto:${emailRecipient}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`

  return (
    <div className={`text-white/50 flex flex-row  gap-2 items-center`}>
      <svg
        width="1rem"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.48438 17.8438C2.83594 17.8438 2.625 17.3594 3 16.8906C3.3125 16.4844 4.0625 15.6406 4.53125 14.8594C4.60938 14.7031 4.57031 14.5859 4.40625 14.5C1.80469 13.0859 0.3125 10.8047 0.3125 8.28125C0.3125 4.17969 4.39844 0.875 9.5 0.875C14.6016 0.875 18.6875 4.17969 18.6875 8.28125C18.6875 12.6875 14.4922 15.6875 8.84375 15.6953C8.77344 15.6953 8.6875 15.6875 8.58594 15.6797C8.45312 15.6797 8.32031 15.7188 8.16406 15.8281C6.69531 16.8672 4.44531 17.8438 3.48438 17.8438Z"
          fill="#7F7F7F"
          fillOpacity="0.5"
        />
        <path
          d="M3.48438 17.8438C2.83594 17.8438 2.625 17.3594 3 16.8906C3.3125 16.4844 4.0625 15.6406 4.53125 14.8594C4.60938 14.7031 4.57031 14.5859 4.40625 14.5C1.80469 13.0859 0.3125 10.8047 0.3125 8.28125C0.3125 4.17969 4.39844 0.875 9.5 0.875C14.6016 0.875 18.6875 4.17969 18.6875 8.28125C18.6875 12.6875 14.4922 15.6875 8.84375 15.6953C8.77344 15.6953 8.6875 15.6875 8.58594 15.6797C8.45312 15.6797 8.32031 15.7188 8.16406 15.8281C6.69531 16.8672 4.44531 17.8438 3.48438 17.8438Z"
          fill="#C2C2C2"
        />
      </svg>
      <p className="sm:text-left text-md text-center">
        Having issues? We can help.
        <a
          href={mailtoLink}
          className="underline text-white/50 hover:text-white ml-1"
        >
          Talk to our team.
        </a>
      </p>
    </div>
  )
}

export default GenericFeedback
